import './index.css'
import UploadItem from "../UploadItem";
import {
  Button,
  Divider,
  Dropdown,
  message,
  Modal,
  Pagination,
  Space,
  Spin,
  Switch,
  Tabs,
  Upload,
  UploadProps
} from 'antd';
import React, {useEffect, useRef, useState} from "react";
import {getId, getRandomPathEnabled, postFile} from '../../helpers/file';
import RightLink from "./RightLink";
import {DeleteOutlined, DownloadOutlined} from "@ant-design/icons";
import {downloadToCsv, downloadToExcel} from "../../helpers/csv";
import BatchActions from './BatchActions';
import ErrorBoundary from "../ErrorBoundary";
import UrlUpload, {eventBus} from "./UrlUpload";

const MAX_CONCURRENT = 3;

const { Dragger } = Upload;

const UPLOAD_KEY = 'upload_key';

/**
 * 上传出错的提示
 * @param errorMessage
 * @param fileName
 */
const showUploadError = (errorMessage: string, fileName: string) => {
  Modal.error(
    {
      // content: `${info.file.name} 上传失败, 原因如下： ${(res as any).message}`,
      content: (
        <div>
          <span>{fileName} 上传失败</span>
          <Divider orientation={'left'}><span style={{fontSize: '12px'}}>详细原因如下:</span></Divider>
          <span>{errorMessage}</span>
          <Divider orientation={'left'}><span style={{fontSize: '12px'}}>自行购买VIP:</span></Divider>
          <span
            style={{color: 'red'}}>
                    1. <a href={"https://c.fakamiao.top/shopDetail/Wte5t6"} target={'_blank'}>点击购买会员</a> <a
            href={"https://www.zhufaka.cn/shop/R8QB4K01"} target={'_blank'}>备用地址</a>
                    2. 付款获得会员卡号+密码
                    3. 返回 {(window as any).systemTitle || '敖武的图床'} 登录
                    4. 激活会员
                    5. 使用
                  </span>
          <Divider orientation={'left'}><span style={{fontSize: '12px'}}>更多技术支持:</span></Divider>
          <img style={{margin: '0 auto', display: 'block'}}
               src={"https://z.wiki/autoupload/20250503/OG1U/1126X1494/mmqrcode1746280934239.png"} width={'257px'}
               height={'257px'}/>
        </div>
      ),
      title: '上传失败',
    }
  );
}

/**
 *
 * @author dongdong.fdd
 * @Company AutoNavi Co.,Ltd.
 * @date 2023/7/29 15:26
 */
function Body() {
  const [uuid, setUuid] = useState<string | null>();
  const [list, setList] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [keyword, setKeyword] = useState('');
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState<Record<string, string>>({});
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [currentDir, setCurrentDir] = useState('');
  const [enableFolderUpload, setEnableFolderUpload] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const queueRef = useRef<any>([]);
  const activeCountRef = useRef(0);
  const abortControllerRef = useRef<AbortController | null>(null);

  const runNext = () => {
    if (queueRef.current.length === 0 || activeCountRef.current >= MAX_CONCURRENT) {
      return;
    }

    const nextTask = queueRef.current.shift();
    activeCountRef.current++;
    nextTask().finally(() => {
      activeCountRef.current--;
      runNext();
    });
  };

  const customRequest = async ({ file, onSuccess, onError }: any) => {
    queueRef.current.push(async () => {
      try {
        await postFile(file, (percent) => {
                  let content = `上传进度：${percent}%`;
                  if (percent == 100) {
                    content = '上传完成，后台校验中...'
                  }
                  message.info({
                    duration: 1000,
                    content,
                    key: UPLOAD_KEY
                  });
                }, (errorMessage, fileName) => {
                  showUploadError(errorMessage, fileName);
                }, currentDir
        ).catch(() => {}) as any;
        message.info({
          duration: 1000,
          content: "上传成功",
          key: UPLOAD_KEY
        });
        loadHistory()
      } catch (err) {
        onError(err);
        message.error(`${file.name} 上传失败`);
      }
    });

    runNext(); // 每次加任务时尝试执行下一个
  };

  const updateUserInfo = () => {
    fetch('/login/info', {
      method: 'GET',
    }).then(res => res.json()).then((e) => {
      if (e.isSuccess) {
        const _info = e.detail;
        if (_info.config && typeof _info.config === 'string') {
          try {
            _info.config = JSON.parse(_info.config);
          } catch (e) {
            console.error('config is not json string', _info.config);
          }
        }
        setUserInfo(_info);
        (window as any)._info = _info;
      }
    })
  }

  useEffect(() => {
    updateUserInfo();
    
    // 检测是否为移动端
    const checkMobile = () => {
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
      setIsMobile(isMobileDevice);
    };
    
    checkMobile();
  }, [])

  // 监听URL上传成功事件，自动重新加载历史数据
  useEffect(() => {
    const handleUrlUploadSuccess = (data: any) => {
      console.log('URL上传成功，重新加载历史数据:', data);
      loadHistory();
    };

    eventBus.on('urlUploadSuccess', handleUrlUploadSuccess);
    
    return () => {
      eventBus.off('urlUploadSuccess', handleUrlUploadSuccess);
    };
  }, []);

  useEffect(() => {
    setUuid(getId());
  }, [])

  // 加载历史数据，支持目录参数
  const loadHistory = (dir?: string) => {
    // 取消上一次的请求
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // 创建新的 AbortController，兼容不支持的浏览器
    const controller = window.AbortController ? new AbortController() : null;
    abortControllerRef.current = controller;

    setLoading(true);
    fetch(`/img/history?uid=${getId()}&page=${current}&pageSize=${pageSize}&dir=${encodeURIComponent(dir || currentDir || '')}&keyword=${keyword}`, {
      signal: controller?.signal
    })
      .then(res => res.json())
      .then(pageData => {
        setLoading(false);
        setList(pageData.data);
        setTotal(pageData.total);
      })
      .catch(error => {
        // 如果是取消请求，不需要处理错误
        if (error.name !== 'AbortError') {
          setLoading(false);
          console.error('加载历史数据失败:', error);
        }
      });
  };

  // 导出
  const keyMap = {
    fileName: '文件名称',
    contentType: '文件类型',
    url: '访问链接',
    time: '上传时间',
    storageType: '存储类型'
  };
  const exportPageList = (type: 'csv' | 'excel') => {
    if (list.length === 0) {
      message.warning('没有数据可以导出');
      return;
    }
    if (type === 'csv') {
      downloadToCsv(list, keyMap);
    } else {
      downloadToExcel(list, keyMap);
    }
  }

  // 清空当前页的数据
  const deletePageList = () => {
    const doDelete = window.confirm("即将删除当前页的所有数据，是否删除？")
    if (doDelete) {
      const promiseList = list && list.map((item) => {
        return fetch(`/img/delete?id=${item.id}&uid=${getId()}`, {
          method: 'DELETE'
        });
      }) || []
      Promise.all(promiseList).then(() => {
        message.success("当前页的内容已全部清空");
        loadHistory()
      })
    }
  }

  useEffect(() => {
    const handlePaste = async (event: any) => {
      if(event.target.tagName == 'INPUT' && event.target.type == 'text') {
        return;
      }
      const items = (event.clipboardData).items || [];
      message.info({
        content: `开始上传`,
        key: UPLOAD_KEY
      });
      console.info('items is', items);
      if(items.length > 1 && items[0].kind != 'string') {
        // 选择了多个文件
        const files = [...items].map((item: any) => {
          return item.getAsFile();
        })
        for(const file of files) {
          await new Promise(async (resolve) => {
            if(file) {
              try {
                const result = await postFile(file, (percent) => {
                  let content = `上传进度：${percent}%`;
                  if (percent == 100) {
                    content = '上传完成，后台校验中...'
                  }
                  message.info({
                    duration: 1000,
                    content,
                    key: UPLOAD_KEY
                  });
                }, (errorMessage, fileName) => {
                  showUploadError(errorMessage, fileName);
                }, currentDir
                ).catch(() => {});
                console.info('upload result is ', result);
                resolve(true);
              } catch(e) {
                console.error(e);
                resolve(true);
              }
            }
          })
        }
        message.success({
          duration: 3,
          content: `上传成功`,
          key: UPLOAD_KEY
        });
        loadHistory();
      } else {
        for(const item of items) {
          console.info('item is ', item, items.length);
          await new Promise(async (resolve) => {
            const file = item && item.getAsFile();
            if(file) {
              try {
                const result = await postFile(file, (percent) => {
                  let content = `上传进度：${percent}%`;
                  if (percent == 100) {
                    content = '上传完成，后台校验中...'
                  }
                  message.info({
                    duration: 1000,
                    content,
                    key: UPLOAD_KEY
                  });
                }, (errorMessage, fileName) => {
                  showUploadError(errorMessage, fileName);
                }, currentDir
                ).catch(() => {});
                console.info('upload result is ', result);
                resolve(true);
              } catch(e) {
                console.error(e);
                resolve(true);
              }
            } else {
              // 尝试读取剪切板中的内容
              if(item.type.match('^text/plain')) {
                item.getAsString(async (clipboardContent: any) => {
                  const blob = await new Blob([clipboardContent]);
                  const file = new File([blob], '来自剪切板的文本.txt', {
                    type : "text/plain;charset=utf-8"
                  });
                  await postFile(file, (percent) => {
                    let content = `上传进度：${percent}%`;
                    if (percent == 100) {
                      content = '上传完成，后台校验中...'
                    }
                    message.info({
                      duration: 1000,
                      content,
                      key: UPLOAD_KEY
                    });
                  }, (errorMessage, fileName) => {
                    showUploadError(errorMessage, fileName);
                  }, currentDir
                  ).catch(() => {});
                  resolve(true);
                })
              } else {
                console.info('not found file')
                message.warning('剪切板中未找到任何文件。')
                resolve(true);
              }
            }
          })
          console.info('upload done', items.length);
        }
        message.success({
          duration: 3,
          content: `上传成功`,
          key: UPLOAD_KEY
        });
        loadHistory()
      }
    }

    document.addEventListener('paste', handlePaste);

    return () => {
      document.removeEventListener('paste', handlePaste);
    }
  }, [currentDir, current])

  useEffect(() => {
    loadHistory();
  }, [uuid, current, pageSize, currentDir, keyword])

  useEffect(() => {
    setCurrent(1);
  }, [keyword]);

  // 组件卸载时取消正在进行的请求
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [])

  useEffect(() => {
    eventBus.on('urlUploadSuccess', () => {
      loadHistory();
    });
    return () => {
      eventBus.off('urlUploadSuccess');
    };
  }, []);

  const props: UploadProps = {
    showUploadList: false,
    name: 'file',
    multiple: true,
    directory: enableFolderUpload,
    action: '/img/upload',
    data: (file) => {
      message.info({
        content: `开始上传`,
        key: UPLOAD_KEY
      });
      return {
        fileName: (file as any).webkitRelativePath || file.name,
        uid: getId(),
        dir: currentDir,
        randomPath: getRandomPathEnabled()
      }
    },
    onChange(info) {
      const { status} = info.file;
      const event = info.event;
      console.info('status is', status, event?.percent);
      if (status == 'uploading') {
        let content = `上传进度：${event?.percent?.toFixed?.(0)}%`;
        if (event?.percent?.toFixed?.(0) == '100') {
          content = '上传完成，后台校验中...'
        }
        message.info({
          duration: 1000,
          content,
          key: UPLOAD_KEY
        });
      }

      if (status === 'done') {
        message.success({
          duration: 3,
          content:`${info.file.name} 上传成功`,
          key: UPLOAD_KEY
        });
        loadHistory();
      } else if (status === 'error') {
        const res = info.file.response;
        if (res && res.status === 413) {
            showUploadError("文件太大了。", info.file.name);
        } else if ((res as any).success === false) {
            showUploadError((res as any).message, info.file.name);
        } else {
            message.error({
                content: `${info.file.name} 上传失败`,
                key: UPLOAD_KEY
            });
        }
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const handleSelect = (id: any, checked: boolean) => {
    setSelectedIds(prev => checked ? [...prev, id] : prev.filter(i => i !== id));
  };

  // 处理文件夹上传开关变化
  const handleFolderUploadChange = (checked: boolean) => {
    setEnableFolderUpload(checked);
  };

  return (
    <div
      className="Body"
      style={{
        paddingLeft: '30px',
        paddingRight: '30px',
      }}
    >
      <div className="title" style={{marginTop: "20px", marginBottom: "12px"}}>
        <h1
          title={`${(window as any).systemTitle || "敖武的图床"}, 电商图床, 免费公共图床, 提供图片上传和图片外链服务, 原图保存, 全球CDN加速，图床工具，图床在线，图床链接，外链图床。`}
          style={{
            "height": "28px",
            "fontFamily": "PingFangSC",
            "fontWeight": 500,
            "fontSize": "20px",
            "color": "#21242E",
            "lineHeight": "28px",
            margin: '0px',
            display: 'inline-block'
          }}
        >
          {(window as any).systemTitle || "敖武的图床"}

        </h1>
        <span
          title="获取身份唯一标识"
          style={{
            "display": "inline-flex",
            "alignItems": "center",
            "fontSize": "12px",
            "cursor": "pointer",
            "paddingLeft": "5px",
            'color': 'red',
            "lineHeight": "14px"
          }}
          onClick={() => {
            Modal.info({
              title: '联系站长',
              content: (
                <div
                  className={"qr-code-ctn"}
                  style={{
                    marginRight: '34px'
                  }}
                >
                  <p className={"mailto-url"}>
                    <span style={{display: 'block'}}>站长微信： 18215600321</span>
                    <span style={{display: 'block'}}>QQ 交流群： 756691064</span>
                    <a style={{display: 'block'}} href="mailto:fudongdong@fudongdong.com"
                       target={'_blank'}>邮箱：fudongdong@fudongdong.com</a>
                  </p>
                  <Tabs>
                    <Tabs.TabPane tab="公众号" key="wechat">
                      <div className="qr-code">
                        <img src={"https://z.wiki/autoupload/20231209/2Vsb.1164X1122-IMG_1279.JPG"} width={"100%"}/>
                      </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="用户身份" key="uid">
                      <div className="qr-code">
                        <img src={"https://playground.z.wiki/qrcode/generateQRCode?data=" + getId() + " " + document.cookie}
                             width={"100%"}/>
                      </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Telegram" key="tg">
                      <div className="qr-code">
                        <img src={"https://tc-new.z.wiki/autoupload/fdd/20250812/iR01/862X950/image.png"} width={"100%"}/>
                      </div>
                    </Tabs.TabPane>
                  </Tabs>
                </div>
              )
            })
          }}
        >
          👉联系站长
        </span>
      </div>

      <div
        className="opts"
        style={{
          paddingBottom: '16px'
        }}
      >
        <div className="get-share-file">

        </div>
        <div className="links">

        </div>
        <div className="auto-copy">

        </div>
        <div
          className="tips"
          style={{
            color: '#757D8B',
            fontSize: '12px',
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <div className="left">
            复制图片，打开页面并按下<span className={"cmd"}>Ctrl+V</span>或<span className="cmd">Command+V</span>就能自动上传啦~
            {window.location.hostname === 'imgbed.cn' ? (
              <a href={"https://playground.z.wiki/img-cloud/index.html"} target={'_blank'} style={{color: 'red'}}>
                上传过慢？点此使用备用网站
              </a>
            ) : (
              <a href={"https://imgbed.cn/"} target={'_blank'} style={{color: 'red'}}>新域名：imgbed.cn</a>
            )}
          </div>
          <div className="right" style={{flexShrink: 0}}>
            <ErrorBoundary>
              <RightLink/>
            </ErrorBoundary>
          </div>
        </div>
      </div>

      <div
        className="upload-zone"
        style={{
          "height": "178px",
          "backgroundColor": "#FFFFFF",
          "borderRadius": "6px",
          padding: '18px',
        }}
      >
        <Dragger {...props} customRequest={customRequest}>
          <p className="ant-upload-drag-icon" style={{marginTop: '0px', marginBottom: "8px"}}>
            <img src={"https://z.wiki/autoupload/20230731/JQyP.ic_%E5%A2%9E%E5%8A%A0%E8%A1%A8%E6%A0%BC.svg"}/>
          </p>
          <p
            className="ant-upload-text"
            style={{
              fontSize: '14px',
              margin: 0,
            }}
          >
            拖拽文件到此区域或<span style={{color: '#1A66FF'}}> 点此上传 </span>
            到<span style={{color: '#ff4747', fontWeight: 'bold'}}>
            {currentDir == '全部目录' ? '默认目录' : currentDir}
            </span>（已选目录）
          </p>
          <p
            className="ant-upload-hint"
            style={{
              fontSize: '12px',
              margin: 0,
              marginTop: '4px',
            }}
          >
            支持上传照片、视频、ZIP、pdf等多种文件，最大支持100M，上传后支持复制url、base64、Markdown 照片三种方式
          </p>
          {!isMobile && (
            <>
              <br/>
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation()
                }}
                style={{
                  display: 'inline-block'
                }}
              >
                <Switch
                  size="small"
                  style={{marginRight: 4}}
                  checked={enableFolderUpload}
                  onChange={handleFolderUploadChange}
                />
                <span style={{fontSize: 12, whiteSpace: 'nowrap'}}>
                      开启上传文件夹（<span style={{fontWeight: 'bold'}}>仅支持点击上传</span>)）
                    </span>

                    <UrlUpload />
              </div>
            </>
          )}
        </Dragger>
      </div>
      <BatchActions
        onKeywordChange={(keyword) => {
          setKeyword(keyword);
        }}
        onSearch={(kw) => {
          setKeyword(kw);
          setCurrent(1);
          setSelectedIds([]);
          loadHistory();
        }}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        list={list}
        loadHistory={() => loadHistory()}
        currentDir={currentDir}
        onDirChange={dir => {
          setCurrentDir(dir);
          setCurrent(1); // 切换目录时重置为第一页
          setSelectedIds([]); // 切换目录时清空选择
          loadHistory(dir);
        }}
      />

      <Spin spinning={loading}>
        <div
          className="list"
          style={{
            "display": "flex",
            "alignItems": "flex-start",
            "flexDirection": "row",
            "flexWrap": "wrap",
            "alignContent": "flex-start",
            justifyContent: "space-between",
          }}
        >
          {
            (
              <>
                {
                  list?.map((item, index) => {
                    return (
                      <ErrorBoundary key={item.id}>
                        <UploadItem
                          dir={item.dir}
                          index={index}
                          userInfo={userInfo}
                          key={item.id}
                          url={item.url}
                          rawUrl={item.rawUrl}
                          contentType={item.contentType}
                          id={item.id}
                          fileName={item.fileName}
                          time={item.time}
                          size={item.size}
                          illicit={item.illicit}
                          illicitDetails={item.illicitDetails}
                          storageType={item.storageType}
                          onDelete={() => {
                            loadHistory()
                          }}
                          selected={selectedIds.includes(item.id)}
                          onSelect={handleSelect}
                          selectedIds={selectedIds}
                        />
                      </ErrorBoundary>
                    )
                  })
                }
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
                <i className={'hiddenUploadItem'} style={{width: '324px'}} />
              </>
            )
          }

        </div>
      </Spin>

      <div
        className="footer"
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          paddingBottom: "40px",
        }}
      >
        <Space>
          <Pagination
            current={current}
            size={'small'}
            showSizeChanger
            pageSizeOptions={['10', '20', '50', '100', '200', '400', '600', '800', '1600', '3200']}
            total={total}
            showTotal={(total) => `共 ${total} 条数据`}
            pageSize={pageSize}
            onChange={(page, pageSize) => {
              setCurrent(page);
              setPageSize(pageSize);
            }}
          />
          <Dropdown
            menu={{
              items: [
                { key: 'csv', label: '导出当前页为 CSV', onClick: () => exportPageList('csv') },
                { key: 'excel', label: '导出当前页为 Excel', onClick: () => exportPageList('excel') },
              ]
            }}
          >
            <Button icon={<DownloadOutlined />} size={'small'}>导出</Button>
          </Dropdown>
          <Button icon={<DeleteOutlined/>} size={'small'} onClick={deletePageList}>清空</Button>
        </Space>
      </div>
    </div>
  );
}

Body.propTypes = {}

export default Body
